















import { Vue, Component, Prop } from 'vue-property-decorator'
import ItemSkeleton from './cart/CartItemSkeleton.vue'
import Thumb from './BaseSkuThumb.vue'

@Component({
  components: { ItemSkeleton, Thumb },
})
export default class GiftCardListItem extends Vue {
  @Prop() fetching: boolean
  @Prop() firstName: string
  @Prop() lastName: string
  @Prop() email: string
  @Prop() message: string
  @Prop() value: number
  @Prop() deliverBy: Date
  @Prop() id: string
  @Prop() code: string

  remove () {
    this.$emit('remove', this.code)
  }
}
